// Layout-math constants only: importers (skeleton layout, pane layout hook)
// must not pull the pane component itself into the shared bundle.
export const DEFAULT_WORKSPACE_PANE_WIDTH = 480;
export const MIN_WORKSPACE_PANE_WIDTH = 360;
export const PANEL_TRANSITION_MS = 300;

/**
 * Chat floor while the pane is open — below MIN_CHAT_PANE_WIDTH on purpose:
 * the chat squeezes so the summary panel can shrink beside the pane instead
 * of being replaced on typical laptop widths.
 */
export const SQUEEZED_CHAT_PANE_WIDTH = 400;

/**
 * Chat width the allocator tops up to (from SQUEEZED_CHAT_PANE_WIDTH) before
 * the summary and pane get any surplus. Deliberately not MIN_CHAT_PANE_WIDTH:
 * while the pane is docked the transcript is allowed to re-wrap, and a larger
 * top-up would starve the summary and pane at laptop widths.
 */
export const SQUEEZED_CHAT_COMFORT_WIDTH = 640;
